// Domaine — constantes globales partagées entre toutes les apps

export const CURRENCY = 'XAF' as const
export const DEFAULT_CITY = 'Douala' as const
export const DEFAULT_DELIVERY_FEE_FCFA = 500
export const DEFAULT_DELIVERY_RADIUS_KM = 5

// Règles métier — fidélité
export const LOYALTY_PTS_PER_TRANCHE_FCFA = 500 // 1 pt / 500 FCFA
export const LOYALTY_REDEMPTION_RATE_FCFA = 5 // 100 pts = 500 FCFA → 1 pt = 5 FCFA
export const LOYALTY_EXPIRY_DAYS = 365 // Expiration après 12 mois d'inactivité
export const LOYALTY_EXPIRY_NOTICE_DAYS = 30 // Notification J-30 avant expiration

// Niveaux fidélité (seuils inclusifs bas)
export const LOYALTY_TIERS = {
  bronze: { min: 0, max: 499 },
  argent: { min: 500, max: 1999 },
  or: { min: 2000, max: 4999 },
  platine: { min: 5000, max: Infinity },
} as const

// Bonus fidélité
export const LOYALTY_BONUS = {
  profileComplete: 10,
  vitalSignsLogged: 5,
  prescriptionRenewal: 5,
  threeMonthlyPurchases: 20,
  birthdayMultiplier: 2,
} as const

// Stocks & péremption
export const EXPIRY_ALERT_DAYS = [30, 7] as const // Alertes J-30 et J-7

// Livreur
export const DRIVER_GPS_INTERVAL_MS = 30_000 // 30 secondes
export const DRIVER_RATING_MIN_ACTIVE = 3.5
export const DRIVER_RATING_SUSPEND_THRESHOLD = 3.0
export const DRIVER_RATING_WINDOW = 10 // 10 dernières livraisons

// CNPS / IRPP (Cameroun)
export const CNPS_RATE_EMPLOYEE = 0.028 // 2,8% du salaire brut

// API limits
export const CAMERPAY_RATE_LIMIT_PER_MIN = 120
export const SMS_RETRY_ATTEMPTS = 3
export const SMS_RETRY_BACKOFF_MS = 5_000

// Pagination
export const PAGE_SIZE_DEFAULT = 20
export const PAGE_SIZE_MAX = 100

// Validation
export const PHONE_237_REGEX = /^\+237[0-9]{9}$/
export const PIN_LENGTH = 6
export const QR_MIN_SIZE_PX = 200

// Storage limits (octets)
export const STORAGE_FREE_LIMIT_BYTES = 10 * 1024 * 1024 // 10 MB
export const STORAGE_PREMIUM_LIMIT_BYTES = 1 * 1024 * 1024 * 1024 // 1 GB

// Signed URL expiration
export const SIGNED_URL_TTL_SECONDS = 60 * 60 // 1h
export const SHARED_RECORD_TTL_HOURS = 24 // partage dossier patient
